import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { VegetalWallId, VegetalWallOptionId } from '@core/constants/Shape';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import additionalDataFactory from './common/fieldsAdditionalData';

const vegetalWallForm: IForm = {
    formId       : PublishedFormId.VegetalWall,
    type         : FormTypeId.Vegetal,
    thumbnailURL : '/resized-images/forms/vegetalWall.png',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.DestinationShape,
        IFormFieldKey.Type,
        IFormFieldKey.Dimension,
        IFormFieldKey.Vegetals,
        IFormFieldKey.AddOns,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        destinationShape: {
            value   : undefined,
            options : [
                VegetalWallId.VegetalWallIndoor,
                VegetalWallId.VegetalWallOutdoor,
            ],
            required: true,
        },
        type: {
            value   : undefined,
            options : [
                VegetalWallId.VegetalWallStabilized,
                VegetalWallId.VegetalWallArtificial,
                VegetalWallId.VegetalWallNatural,
            ],
            required: true,
        },
        dimension: {
            [FieldDimensionId.Length]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 200, max: 4000 },
                required     : true,
                defaultValue : 1000,
            },
            [FieldDimensionId.Height]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 200, max: 4000 },
                required     : true,
                defaultValue : 1000,
            },
        },
        vegetals: {
            [VegetalWallOptionId.VegetalWallFern]: {
                value : undefined,
                min   : 0,
                max   : 20,
            },
            [VegetalWallOptionId.VegetalWallFoamBall]: {
                value : undefined,
                min   : 0,
                max   : 20,
            },
            [VegetalWallOptionId.VegetalWallFoamLichen]: {
                value : undefined,
                min   : 0,
                max   : 20,
            },
            [VegetalWallOptionId.VegetalWallIvy]: {
                value : undefined,
                min   : 0,
                max   : 20,
            },
            [VegetalWallOptionId.VegetalWallLushNature]: {
                value : undefined,
                min   : 0,
                max   : 20,
            },
            [VegetalWallOptionId.VegetalWallPhilodendron]: {
                value : undefined,
                min   : 0,
                max   : 20,
            },
        },
        addOns: {
            [VegetalWallId.VegetalWallLighting]: {
                value : undefined,
                min   : 0,
                max   : 5,
            },
            [VegetalWallId.VegetalWallLogo]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 500,
            budgetMax          : 20000,
            budgetDefaultValue : 2500,
            budgetStep         : 250,
        }),
        contact: fieldsContact,
    },
};

export default vegetalWallForm;
